module.exports = __webpack_public_path__ + "static/media/empty-files-table.b16494d0.svg";